import { GetEmailThumbnailsResponse } from 'lib/api';
import { emailIconsKeys } from 'lib/api/emailIcons/queryKeys';
import { useAuth } from 'lib/context';
import { useQueryClient } from 'react-query';
import { CovideoGTMVideoAttributes } from '../../types';
import { useSendAndShare } from 'lib/context/send-and-share/provider';
import { CovideoGTMVideoMessageProperties } from '.';

const toMaybeString = (v: unknown) => {
  return !!v ? String(v) : undefined;
};

export const useVideoMessageInteractionCalculation = ({
  iconId,
  linksetId,
  templateId,
  notifyUser,
  sms,
  email,
  templates,
}: {
  iconId?: number;
  linksetId?: number;
  templateId?: number;
  notifyUser?: boolean;
  sms?: boolean;
  email?: boolean;
  templates?: any;
}) => {
  const { userData } = useAuth();
  const queryClient = useQueryClient();
  const { linksets, video } = useSendAndShare();
  const cachedIcons = queryClient.getQueryData<GetEmailThumbnailsResponse>(
    emailIconsKeys.all()
  );
  const getGTMVideoMessageProperties = (): CovideoGTMVideoMessageProperties => {
    const thumbnailsItem = cachedIcons?.templates?.find(
      template => template.id === iconId
    );

    const linkSetItem = linksets.linksets?.find(linkset => {
      return linkset.id === linksetId;
    });

    const templateItem = templates?.find(
      (template: { value: number | undefined }) => template.value === templateId
    );

    const payload: CovideoGTMVideoMessageProperties = {
      notificationViewed: notifyUser ?? undefined,
      landingPage: templateItem?.label ?? toMaybeString(templateId),
      callToAction: linkSetItem?.title ?? toMaybeString(linksetId),
      thumbnails: thumbnailsItem?.title ?? toMaybeString(iconId),
      customerId: toMaybeString(userData.customerId),
      sms,
      email,
    };

    return payload;
  };

  const getGTMVideoAttributesData = (): CovideoGTMVideoAttributes => {
    return {
      videoId: Number(video.id),
      videoTitle: video.title,
      videoLength: video.videoLength,
      videoCustomerName: !!video?.videoRequest?.customerName,
      videoType: video.videoRequest?.videoType || undefined,
    };
  };

  return {
    GTMVideoAttributes: getGTMVideoAttributesData(),
    GTMVideoMessageProperties: getGTMVideoMessageProperties(),
  };
};
